var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoStopping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Gruppe_605",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 30,
    height: 30,
    "data-name": "Gruppe 605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_178",
    fill: "red",
    d: "M 15 0 A 15 15 0 1 0 30 15 A 15 15 0 0 0 15 0 Z m 0 26.25 A 11.263 11.263 0 0 1 3.75 15 A 11.106 11.106 0 0 1 5.833 8.484 L 21.516 24.167 A 11.106 11.106 0 0 1 15 26.25 Z m 9.167 -4.734 L 8.484 5.833 A 11.106 11.106 0 0 1 15 3.75 A 11.263 11.263 0 0 1 26.25 15 a 11.106 11.106 0 0 1 -2.083 6.516 Z",
    "data-name": "Pfad 178"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStopping);
export default __webpack_public_path__ + "static/media/no-stopping.c0e4400dcd61c587f9cf7297eb1c8f0c.svg";
export { ForwardRef as ReactComponent };